jQuery( document ).ready(function($) {
  if($('.faq').length > 0) {

    $('.faq_link').on('click', (e) => {
      $('.faq_step').css('display', 'none')
      $('.faq_step-' + $(e.currentTarget).attr('data-id')).css('display', 'flex')

      $('.faq_link').removeClass('faq_link-active')
      $(e.currentTarget).addClass('faq_link-active')
    })

    $('.faq_item').on('click', (e) => {
      $(e.currentTarget).find('.faq_response').toggle()
      $(e.currentTarget).find('.faq_openner').toggleClass('faq_openner-active')
    })

    $('.instagram').addClass('instagram-special')
    
  }
});
